import PulseLoader from "react-spinners/PulseLoader";
import { Stack } from "@mui/material";

const PulseLoading = ({height}) => {
  return (
    <Stack direction="row" justifyContent="center" alignItems="end" height={height}>
      <PulseLoader color="#1976d2" />
    </Stack>
  );
};

export default PulseLoading;
